module.exports = __webpack_public_path__ + "media/images/icon-select-5d4a48a6b8c7ff50747b3c31a2dea2fa.png";